<script setup>

</script>

<template>
  <div class="bg-gradient-to-r from-primary to-secondary py-0.5"></div>
</template>

<style scoped lang="less">

</style>
